import React from 'react';
import {DocumentView, TestView, HtmlPageView} from './Views';
const $ = window.$;

export default class ContentUI extends React.Component {
    componentDidUpdate() {
        $('html, body').scrollTop(0);
    }

    render() {
        let contentView = undefined;

        switch (this.props.section) {
            case 'publication':
                contentView = <DocumentView />;
                break;
            case 'test':
            case 'test_results':
                contentView = <TestView submitButtonRef={this.props.submitButtonRef} />;
                break;
            case 'blog_post':
            case 'single_html_page':
                contentView = <HtmlPageView />;
                break;
        }

        return contentView;
    }
}
